export const TYPE = {
    TICKET: 1,
    COUPON: 2,
};